import { render, staticRenderFns } from "./TermVerificationModal.vue?vue&type=template&id=da3bd914"
import script from "./TermVerificationModal.vue?vue&type=script&lang=js"
export * from "./TermVerificationModal.vue?vue&type=script&lang=js"
import style0 from "./TermVerificationModal.vue?vue&type=style&index=0&id=da3bd914&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports